import { render, staticRenderFns } from "./UserWithBorder.vue?vue&type=template&id=6a237098&"
import script from "./UserWithBorder.vue?vue&type=script&lang=ts&"
export * from "./UserWithBorder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports